<template>
  <div data-track="Social Ads Creator - Image library tab">
    <div class="level head">
      <div
        class="level-left"
      >This is your Social Ad library where you can download and share your Ads again.
      </div>
      <div class="level-right">
        <span class="filter-label">Date range</span>
        <date-select-filter
          :filter_items="filters.dateFilter.props"
          :styleProp="filters.dateFilter.styleProp"
          @onDateChange="handleDateChange"
          class="custom-dropdown custom-dropdown--small padding-top-0 padding-right-0"
        />
        <span class="filter-label">Channel</span>
        <custom-dropdown
          :options="channelDdOpts"
          class="channel-filter"
          group="adsLibraryChannelFilter"
        />
      </div>
    </div>
    <div class="sectionn">
      <p class="section__head">Social Ads</p>
      <hr class="section_divider"/>

      <div class="has-spinner" v-if="isPaidUser">
        <img class="has-spinner__spinner" src="/static/img/loaders/spinner.svg" v-if="isLoading"/>
        <template v-else>
          <div class="ads-card-container">
            <div :key="index" class="ads-card" v-for="(ads, index) in adsList">
              <div class="ads-card__image-box">
                <img :src="ads.image_thumb" class="ads-card__image"/>
              </div>
              <div class="ads-card__content is-clearfix">
                <div class="level">
                  <div class="level-left">Created:</div>
                  <div class="level-right" v-text="ads.createdAt"></div>
                </div>
                <!--<div class="level">
                  <div class="level-left">Last published:</div>
                  <div class="level-right">
                    <template v-if="ads.last_published">{{ ads.last_published.publishedAt }}</template>
                  </div>
                </div>-->
                <div class="level">
                  <div class="level-left">Channel:</div>
                  <div class="level-right" v-text="channels[ads.channel]"></div>
                </div>
                <custom-dropdown
                  :disabled="isPerformingAction"
                  :options="actionDdOpts(ads, index)"
                  class="action-dd is-pulled-right"
                  group="adsLibraryActionDd"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="upgrade-box" v-else>
        <div class="upgrade-box__header">
          Upgrade
          <img align="right" src="/static/img/ads/lock.svg"/>
        </div>
        <div class="upgrade-box__main">
          <a class="blue-link" href="/billing/edit-plan/g1/monthly">Upgrade</a> your package and start turning your reviews into beautifully designed social proof Ads.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new,no-undef */
import {CustomDropdown, DateSelectFilter} from '@/components'
import {misc} from '@/mixins'
import axios from 'axios'
import localMixin from './mixin.js'

export default {
  name: 'AdsLibrary',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Ads Library'
  },
  components: {
    DateSelectFilter,
    CustomDropdown
  },
  mixins: [misc, localMixin],
  data () {
    return {
      isLoading: false,
      adsList: [],
      channels: {
        fb_feed: 'Facebook',
        inst_post: 'Instagram',
        inst_story: 'Instagram story',
        twitter: 'Twitter',
        linkedin: 'LinkedIn'
      },
      filters: {
        dateFilter: {
          label: 'last_6_months',
          endDate: null,
          startDate: null,
          styleProp: {},
          props: [
            {
              name: 'date',
              label: 'Date',
              showApplyBtn: true,
              dataTrack: 'data-track="Social Ads Creator - Image library tab - Date filter change',
              default: {type: 'months', value: 6, selected: 'Last 6 months'}, // moment.js placeholder in type
              disabled: [],
              elements: [
                'Last 7 days',
                'Previous month',
                'Last 6 months',
                'Last 12 months',
                'Custom'
              ]
            }
          ]
        },
        channel: '',
        page: {
          current: 0,
          total: 1
        }
      },
      isPerformingAction: false,
      lockScroll: true
    }
  },
  created () {
    window.events.$on('custom-dd-changed', data => {
      if (data.group === 'adsLibraryChannelFilter' && data.changedByHuman) {
        this.filters.channel = data.value
      }

      if (data.group === 'adsLibraryActionDd' && data.changedByHuman) {
        this.isPerformingAction = true

        if (data.value === 'download') {
          this.downloadAd(data.data.id, data.data.url)
            .then(() => {
              this.isPerformingAction = false
            })
        } else if (data.value === 'delete') {
          axios.delete(`/business/${this.businessSlug}/ads/${data.data.id}`)
            .then(() => {
              this.adsList.splice(data.data.index, 1)
              this.isPerformingAction = false
            })
        } else if (data.value === 'publish') {
          let promise = new Promise((resolve, reject) => {
            this.publishAd(data.data.url, data.data.channel, resolve)
          })
          promise.then(() => {
            this.isPerformingAction = false
          })
        }
      }
    })

    window.addEventListener('scroll', this.handleScroll)
    this.unlockScroll()
  },
  beforeRouteLeave (to, from, next) {
    window.events.$off('custom-dd-changed')
    window.removeEventListener('scroll', this.handleScroll)
    next()
  },
  computed: {
    channelDdOpts () {
      const opts = [{
        label: 'All',
        value: '',
        selected: true,
        attr: {'data-track': 'Social Ads Creator - Image library tab - Channel filter change'}
      }]
      for (let channel in this.channels) {
        opts.push({label: this.channels[channel], value: channel})
      }
      return opts
    },
    payload () {
      return {
        endDate: this.filters.dateFilter.endDate,
        startDate: this.filters.dateFilter.startDate,
        channel: this.filters.channel
      }
    },
    canFetchList () {
      return (
        this.isPaidUser &&
        !this.isLoading &&
        this.filters.page.current < this.filters.page.total
      )
    }
  },
  methods: {
    actionDdOpts (ads, index) {
      if (ads.channel === 'inst_post' || ads.channel === 'inst_story' || ads.channel === 'twitter' || ads.channel === 'linkedin') {
        return [{
          label: 'Download',
          value: 'download',
          selected: true,
          data: {id: ads.id, url: ads.image},
          attr: {'data-track': 'Social Ads Creator - Image library tab - Download'}
        }, {
          label: 'Delete',
          value: 'delete',
          data: {id: ads.id, index: index},
          attr: {'data-track': 'Social Ads Creator - Image library tab - Delete'}
        }]
      } else {
        return [{
          label: 'Publish',
          value: 'publish',
          selected: true,
          data: {url: ads.image, channel: ads.channel},
          attr: {'data-track': 'Social Ads Creator - Image library tab - Publish'}
        }, {
          label: 'Download',
          value: 'download',
          data: {id: ads.id, url: ads.image},
          attr: {'data-track': 'Social Ads Creator - Image library tab - Download'}
        }, {
          label: 'Delete',
          value: 'delete',
          data: {id: ads.id, index: index},
          attr: {'data-track': 'Social Ads Creator - Image library tab - Delete'}
        }]
      }
    },
    unlockScroll () {
      setTimeout(() => {
        this.lockScroll = false
      }, 1000)
    },
    handleScroll () {
      if (
        window.innerHeight + window.pageYOffset >= document.body.offsetHeight &&
        !this.lockScroll
      ) {
        this.lockScroll = true

        let promise = new Promise((resolve, reject) => {
          this.fetchAds(resolve, reject)
        })
        promise.then(() => {
          this.unlockScroll()
        })
      }
    },
    fetchAds (resolve = null) {
      if (this.canFetchList) {
        this.isLoading = true

        const payload = JSON.parse(JSON.stringify(this.payload))
        payload.page = ++this.filters.page.current
        axios
          .get(`/business/${this.businessSlug}/ads`, {
            params: payload
          })
          .then(({data}) => {
            this.adsList.push(...data.data.data)
            this.filters.page.total = data.data.last_page
            this.isLoading = false

            if (resolve) {
              resolve()
            }
          })
      } else if (resolve) {
        resolve()
      }
    },
    /**
     * Handle Date Dropdown Filter
     * @param {object} dateFilter Date data to sort on
     * @return {void}
     */
    handleDateChange (dateFilter) {
      Object.assign(this.filters.dateFilter, dateFilter)
    }
  },
  watch: {
    payload (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.filters.page.current = 0
        this.filters.page.total = 1
        this.adsList = []
        this.fetchAds()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./_common.scss";

.head {
  margin-top: 20px;
  margin-bottom: 14px;
}

.filter-label {
  font-weight: bold;
  font-size: 14px;
  color: #58595b;
  margin-right: 7px;
  margin-left: 30px;
}

.custom-dropdown {
  margin-right: 0;
}

.channel-filter {
  max-width: 138px;
}

.section_divider {
  margin-top: 5px;
  margin-bottom: 15px;
}

.ads-card-container {
  display: flex;
  flex-wrap: wrap;
}

.ads-card {
  width: 278px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px rgba(216, 216, 216, 0.32);
  margin: 0 14px 13px 0;
}

.ads-card__image-box {
  background-image: url("/static/img/ads/ads_card_bg.jpg");
  padding: 11px 24px;
  text-align: center;
}

.ads-card__image {
  max-width: 228px;
  max-height: 119px;
}

.ads-card__content {
  padding: 8px 11px 9px 10px;
}

.ads-card .level {
  margin-bottom: 9px;
}

.action-dd {
  max-width: 117px;
}

.action-dd >>> .button.button-dropdown {
  padding-left: 16px !important;
  padding-top: 7px;
  padding-bottom: 4px;
  border-color: rgba(88, 89, 91, 0.32) !important;
}

.action-dd >>> .button.button-dropdown span {
  font-size: 11px !important;
  color: #58595b;
}

.action-dd >>> button.button-dropdown::after {
  height: 8px;
  width: 8px;
  margin-top: -5px;
  border-width: 2px;
  right: 9px;
}

.action-dd >>> .label-filters {
  font-size: 11px !important;
}

.action-dd >>> .border-bottom-dbdbdb {
  padding: 8px 15px !important;
  border: none !important;
}

.action-dd >>> .is-select-active {
  background-color: #eff0f1;
}

.action-dd >>> .dropdown-menu {
  border: 1px solid rgba(88, 89, 91, 0.32) !important;
  margin-top: 1px;
}

.upgrade-box {
  width: 501px;
  margin-left: 2px;
}

.upgrade-box__header {
  color: #3b3c3d;
  padding: 8px 18px 10px;
}

.upgrade-box__main {
  padding: 15px 18px 17px;
  line-height: 19px;
}

@media screen and (max-width: 1280px) {
  .custom-dropdown--small {
    width: 233px;
  }

  .filter-label {
    font-size: 13px;
  }

  .custom-dropdown--small >>> .button.button-dropdown span {
    margin-left: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/social-integration/social-ads/AdsLibrary.vue